/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import { useReduxBridge } from '@xanadu/ui-shared/contexts/ReduxBridgeContext';
import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';

import { getClientLogo, getClientStyledText } from '../../utils';

import styles from './SignUpHead.module.scss';

// TODO this should not be here, where should it be?
// For max flexibility we should have a more focused brand version

const SignUpHead = ({ activeStep, handleStepClick, totalSteps }) => {
  const { clientName, clientSite } = useReduxBridge() || {};

  const { t } = useImprovedTranslation();

  const styledSpan = getClientStyledText(clientName, clientSite, { size: 36 });

  const ClientLogo = useMemo(() => {
    if (totalSteps !== 1) {
      return null;
    }
    return getClientLogo(clientName, clientSite, {
      wrapperClassName: styles.logoWrapper,
    });
  }, [clientName, clientSite, totalSteps]);

  const getStepClass = useCallback(
    (step) =>
      classNames({
        [styles.step]: true,
        [styles['step--active']]: step === activeStep,
        [styles['step--disabled']]: step > activeStep,
      }),
    [activeStep]
  );

  const mainClass = classNames({
    [styles.main]: true,
    [styles['main--noSteps']]: totalSteps === 1,
  });

  const joinClass = classNames({
    [styles.join]: true,
    [styles['join--noSteps']]: totalSteps === 1,
  });

  return (
    <div className={mainClass}>
      <div className={joinClass}>
        <div>{t('Join')}</div>
        {totalSteps === 1 ? <ClientLogo /> : styledSpan}
      </div>
      {totalSteps > 1 && (
        <div className={styles.steps}>
          {[...Array(totalSteps)].map((_, index) => {
            const stepId = `step-${index + 1}`;
            return (
              <button
                key={stepId}
                className={getStepClass(index)}
                onClick={handleStepClick(index)}
                disabled={activeStep < index}
              >
                {index + 1}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

SignUpHead.propTypes = {
  activeStep: PropTypes.number.isRequired,
  handleStepClick: PropTypes.func.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default SignUpHead;
